export const AMPLITUDE_SESSION_ID = 'nugsnet:telemetryjs:amplitude:sessionId'

export const AMPLITUDE_USER_CONTENT_PLAYED = 'User_Content_Played'
export const AMPLITUDE_USER_PLAYBACK_INITIATED = 'User_Playback_Initiated'
